/*
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import Vue from "vue";
import MainApp from "@/libs/MainApp";
import * as lob from "lodash/object";
import MainStub from "@/libs/world-cup/MainStub";
import MainOption from "@/libs/world-cup/MainOption";

export default class WorldCupComponent extends Vue {
  $root: MainApp;

  onDebug(owner: any, name: string, context?: any) {
    if (
      this.$root.$config.option.debug.callback === undefined ||
      this.$root.$config.option.debug.callback === null
    ) {
      return;
    }

    this.$root.$config.option.debug.callback(owner, name, context);
  }

  getData(name: string, value?: any): any {
    return lob.get(this.$root.$config.data, name, value);
  }

  getStoreData(store: any, value?: any): any {
    return lob.get(store, this.getYear(), value);
  }

  getYear(): number {
    return this.$root.$config.year;
  }

  getHost(): string {
    return this.$root.$config.host;
  }

  getConfig(): MainStub {
    return this.$root.$config;
  }

  getOption(): MainOption {
    return this.getConfig().option;
  }

  getLanguage(): string {
    return this.$root.$config.language;
  }
}
